import { render, staticRenderFns } from "./AncillariesCalculator.vue?vue&type=template&id=af4d1cde&scoped=true"
import script from "./AncillariesCalculator.vue?vue&type=script&lang=js"
export * from "./AncillariesCalculator.vue?vue&type=script&lang=js"
import style0 from "./AncillariesCalculator.vue?vue&type=style&index=0&id=af4d1cde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4d1cde",
  null
  
)

export default component.exports